import find from 'lodash/find';

export const collectionPages = (state, getters, rootState) => {
  let page = parseInt(rootState.route.params.page) || 1,
    numPages = state.maxPages < 5 ? state.maxPages : 5,
    pages = [];

  if (page <= Math.ceil(numPages / 2)) {
    for (let i = 1; i <= numPages; i++) {
      pages.push(i);
    }
  } else if (page > state.maxPages - Math.floor(numPages / 2)) {
    for (let i = state.maxPages; i > state.maxPages - numPages; i--) {
      pages.push(i);
    }
    pages.reverse();
  } else {
    return [page - 2, page - 1, page, page + 1, page + 2];
  }

  return pages;
};

export const collectionFormattedProductType = state => {
  let productType = find(state.productTypes, productType => productType.id == state.selectedProductType);

  return productType ? productType.name : null;
};

export const collectionSelectedSortText = state => {
  return find(state.sortOptions, option => option.key === state.selectedSort).value;
};

export const defaultSort = state => {
  const opts = {
    AGE: 'age:DESC',
    SALES: 'orders:DESC',
    MANUAL: 'priority:ASC',
  };

  return opts[state.info.default_sort];
};